/*
 * @Author: wangliang
 * @LastEditTime: 2023-08-22 17:25:41
 * @Description:
 * @LastEditors: wangliang wangliang@wiz.top
 */
import { instance as cloudRender } from 'wiz-cloud-render'
import {
  POINT_SELETE_COLLECTION,
  MOVE_COLLECTION,
  MEASURE_COLLECTION,
  UNALLOW_COEXIST_COM,
  ROAM_COLLECTION,
} from './basicCode'

// key 为索引 0 递增， value 为当前类型集合
const OPERATION_COLLECTION = {
  // 只通过code调用实例 开启、关闭操作
  0: [...POINT_SELETE_COLLECTION, ...MOVE_COLLECTION, ...MEASURE_COLLECTION, ...ROAM_COLLECTION],
  1: [],
}

/**
 * @description: 根据code找到对应索引
 * @param {*} code 激活功能编码
 * @return {*}
 */
const getOperationType = (code) => {
  return _.findIndex(Object.values(OPERATION_COLLECTION), (item) => {
    return _.includes(item, code)
  })
}

/**
 * @description: 销毁基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @return {*}
 */
const destroyCloseBasicTab = async (code, player) => {
  const operationType = getOperationType(code)
  switch (operationType) {
    case 0:
      const closeRes = await cloudRender.Tool.setTool(code, false, player)
      return closeRes
    default:
      break
  }
  return {}
}

const removeAcitveAblity = (unAllowCode, activeBasicList, player) => {
  // 删除当前code
  _.remove(activeBasicList, (activeCode) => {
    return _.eq(activeCode, unAllowCode)
  })
  // 清空当前code对应功能
  destroyCloseBasicTab(unAllowCode, player)
}

/**
 * @description: 销毁互斥基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const destroyUnallowBasicTab = (code, player, activeBasicList) => {
  // 不存在互斥功能
  if (_.isEmpty(UNALLOW_COEXIST_COM[code])) {
    return
  }
  _.forEach(UNALLOW_COEXIST_COM[code], (unAllowCode) => {
    const codeIndex = _.includes(activeBasicList, code)
    if (codeIndex) {
      removeAcitveAblity(unAllowCode, activeBasicList, player)
    }
  })
}

/**
 * @description: 初始化基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const initActiveBasicTab = async (code, player, activeBasicList) => {
  // 销毁互斥相关功能
  destroyUnallowBasicTab(code, player, activeBasicList)
  const operationType = getOperationType(code)
  switch (operationType) {
    case 0:
      const openRes = await cloudRender.Tool.setTool(code, true, player)
      return openRes
    default:
      break
  }

  return {}
}

export { initActiveBasicTab, destroyCloseBasicTab }
